import { render, staticRenderFns } from "./salesAreaMaintenanceIndex.vue?vue&type=template&id=2fa8de28"
import script from "./salesAreaMaintenanceIndex.vue?vue&type=script&lang=js"
export * from "./salesAreaMaintenanceIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports